// src/components/CategoryCards.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getHomepageCategoryCards } from "../services/homepage.api";
import { saveProductReturnPosition } from "../utils/navigationMemory";

function CategoryCards() {
  const navigate = useNavigate();
  const [cards, setCards] = useState([]);
const [loading, setLoading] = useState(true);
const [activeIndex, setActiveIndex] = useState(0);
  const [slideDirection, setSlideDirection] = useState("next");
  const [manualSwitchCount, setManualSwitchCount] = useState(0);

  useEffect(() => {
  let mounted = true;

  setLoading(true);

  getHomepageCategoryCards()
    .then((rows) => {
      if (!mounted) return;
      setCards(Array.isArray(rows) ? rows : []);
    })
    .catch(() => {
      if (mounted) setCards([]);
    })
    .finally(() => {
      if (mounted) setLoading(false);
    });

  return () => {
    mounted = false;
  };
}, []);

  useEffect(() => {
  if (cards.length <= 1) return;

  const timer = setInterval(() => {
    setSlideDirection("next");
    setActiveIndex((prev) => (prev === cards.length - 1 ? 0 : prev + 1));
  }, 4000);

  return () => clearInterval(timer);
}, [cards.length, manualSwitchCount]);

const CategoryCardsSkeleton = () => (
  <section
    className="w-full mt-0 md:mt-[157px] mb-4 px-0 py-0 overflow-hidden bg-[#F6EFE9]"
  >
    <div className="relative w-full flex items-center justify-center px-3 md:px-0 bg-[#F6EFE9]">
      <div
        className="
          w-full
          max-w-none
          aspect-[4/5]
          md:aspect-auto
          md:h-[88vh]
          md:border-t-[2px]
          md:border-t-black
          bg-gray-200
          animate-pulse
          overflow-hidden
        "
      >
        <div className="w-full h-full bg-gradient-to-br from-gray-100 via-gray-200 to-gray-100" />
      </div>

      <div className="absolute left-5 md:left-8 top-1/2 -translate-y-1/2 w-[40px] h-[40px] md:w-14 md:h-14 bg-white/70 border border-white/60 animate-pulse" />
      <div className="absolute right-5 md:right-8 top-1/2 -translate-y-1/2 w-[40px] h-[40px] md:w-14 md:h-14 bg-white/70 border border-white/60 animate-pulse" />
    </div>
  </section>
);

  const activeCard = cards[activeIndex];

  const goPrev = (e) => {
  e.stopPropagation();
  setSlideDirection("prev");
  setActiveIndex((prev) => (prev === 0 ? cards.length - 1 : prev - 1));
  setManualSwitchCount((prev) => prev + 1);
};

const goNext = (e) => {
  e.stopPropagation();
  setSlideDirection("next");
  setActiveIndex((prev) => (prev === cards.length - 1 ? 0 : prev + 1));
  setManualSwitchCount((prev) => prev + 1);
};

  const handleClick = (e) => {
  if (!activeCard?.key) return;

  saveProductReturnPosition({
    element: e.currentTarget,
  });

  if (activeCard.key === "all-products") {
    navigate("/all-products", {
      state: { from: "home" },
    });
    return;
  }

  navigate(`/products?category=${activeCard.key}`, {
    state: { from: "home" },
  });
};

  if (loading) return <CategoryCardsSkeleton />;

if (!cards.length || !activeCard) return null;

  return (
  <>
    <style>
  {`
    @keyframes categorySlideNext {
      from {
        opacity: 0;
        transform: translateX(26px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    @keyframes categorySlidePrev {
      from {
        opacity: 0;
        transform: translateX(-26px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    .category-slide-next {
      animation: categorySlideNext 520ms ease-out both;
    }

    .category-slide-prev {
      animation: categorySlidePrev 520ms ease-out both;
    }
  `}
</style>

    <section
  className="w-full mt-0 md:mt-[157px] mb-4 px-0 py-0 overflow-hidden"
  style={{ backgroundColor: "#F6EFE9" }}
>
  <div
    className="
      relative
      w-full
      flex items-center justify-center
      px-3 md:px-0
    "
    style={{ backgroundColor: "#F6EFE9" }}
  >
        {cards.length > 1 && (
          <button
            type="button"
            onClick={goPrev}
            aria-label="Previous slide"
            className="
  absolute left-5 md:left-8
  top-1/2 -translate-y-1/2
  z-10
  w-[40px] h-[40px] md:w-14 md:h-14
  rounded-none
  bg-white/80 md:bg-white/45
  border border-white/50
  shadow-sm
  flex items-center justify-center
  text-2xl md:text-3xl
  font-light
  text-gray-800
  active:scale-95
  transition
"
          >
            ‹
          </button>
        )}

        <button
  type="button"
  onClick={handleClick}
  className="
    block
    overflow-hidden
    shadow-none md:shadow-[0_8px_24px_rgba(0,0,0,0.10)]
    active:scale-[0.995]
    transition
    w-full
    max-w-none
    aspect-[4/5]
    md:aspect-auto
    md:h-[88vh]
    md:border-t-[2px]
    md:border-t-black
  "
  style={{ backgroundColor: "#F6EFE9" }}
>
          <div
  key={activeCard.id || activeCard.key || activeIndex}
  className={`
    w-full h-full
    transform transition-all duration-500 ease-out
    animate-categorySlide
    ${
      slideDirection === "next"
        ? "category-slide-next"
        : "category-slide-prev"
    }
  `}
>
  <img
  src={activeCard.mobile_image}
  alt=""
  loading="eager"
  decoding="async"
  fetchPriority="high"
  className="
    w-full h-full
    object-cover
    md:hidden
  "
/>

  <img
  src={activeCard.desktop_image || activeCard.mobile_image}
  alt=""
  loading="eager"
  decoding="async"
  fetchPriority="high"
  className="
    hidden md:block
    w-full h-full
    object-cover
  "
/>
</div>
        </button>

        {cards.length > 1 && (
          <button
            type="button"
            onClick={goNext}
            aria-label="Next slide"
            className="
  absolute right-5 md:right-8
  top-1/2 -translate-y-1/2
  z-10
  w-[40px] h-[40px] md:w-14 md:h-14
  rounded-none
  bg-white/80 md:bg-white/45
  border border-white/50
  shadow-sm
  flex items-center justify-center
  text-2xl md:text-3xl
  font-light
  text-gray-800
  active:scale-95
  transition
"
          >
            ›
          </button>
        )}
      </div>
    </section>
    </>
  );
}

export default CategoryCards;
